import React, { createContext, useEffect, useState } from "react";
import { adminGetProfileData } from "../redux/auth/slice";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { Provider } from "./layoutContext";
import Sidebar from "./Sidebar";
import Header from "./Header";
import RippleLoader from "../components/RippleLoader/RippleLoader";

export const AdminContext = createContext({});

const MainLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isAsideOpen, setIsAsideOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  const getAccessToken = sessionStorage.getItem("accessToken");

  const { getProfileData } = useSelector((store) => ({
    getProfileData: store?.authData?.adminGetProfileDataStatus?.data,
  }));

  useEffect(() => {
    if (getAccessToken) {
      dispatch(adminGetProfileData({ navigate })).then(() => {
        setIsLoading(false);
      });
    }
  }, [getAccessToken]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setIsAsideOpen(false);
      } else {
        setIsAsideOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={`bg-lightyellow ${isLoading ? "h-screen" : ""}`}>
      {getAccessToken ? (
        <AdminContext.Provider value={getProfileData}>
          <Provider value={{ isAsideOpen, setIsAsideOpen }}>
            {isLoading ? (
              <RippleLoader />
            ) : (
              <div className="flex flex-col h-screen overflow-hidden">
                <Header />

                <div className="flex flex-1 overflow-hidden">
                  {/* Sidebar */}
                  {isAsideOpen && (
                    <div
                      className={`fixed md:relative sm:relative z-50 top-0 left-0 h-full bg-white border-r border-gray transition-transform duration-300 ${
                        isAsideOpen ? "translate-x-0" : "-translate-x-full"
                      } md:translate-x-0 w-64 md:z-auto mt-16 sm:mt-0 `}
                    >
                      <Sidebar />
                    </div>
                  )}

                  {/* Main Content */}
                  <div className="flex-1 overflow-y-auto bg-light_background_default px-4 sm:px-6 py-6">
                    <Outlet />
                  </div>
                </div>
              </div>
            )}
          </Provider>
        </AdminContext.Provider>
      ) : (
        <Navigate to={"/login"} replace />
      )}
    </div>
  );
};

export default MainLayout;
